import { gapAnalysisFiltersActions as actions } from '../../../../redux/actions'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks'
import Checkbox, { type CheckboxChangeEvent } from '../../../UI/checkbox/Checkbox'
import SimpleInput from '../../../UI/simple-input/SimpleInput'

const DisplayOptionsGA = () => {
  // Local state
  // State
  const dispatch = useAppDispatch()
  const gapAnalysisFilters = useAppSelector(state => state.gapAnalysisFilters)

  // Handlers
  const handleGridlineFrequencyChange = (frequency: string | number) => {
    dispatch(actions.setGridlinesFrequency(Number(frequency)))
  }
  const handleFixGridlineFrequency = () => {
    if (gapAnalysisFilters.gridlinesFrequency > 10) {
      dispatch(actions.setGridlinesFrequency(10))
    } else if (gapAnalysisFilters.gridlinesFrequency < 1) {
      dispatch(actions.setGridlinesFrequency(1))
    }
  }
  const toggleShowGridlines = (selection?: CheckboxChangeEvent) => {
    dispatch(actions.setShowGridSeparator(selection?.checked ?? false))
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
      <Checkbox
        label='Show Gridlines'
        name='showGridLines'
        checked={gapAnalysisFilters.showGridSeparator}
        onChange={toggleShowGridlines}
      />
      {gapAnalysisFilters.showGridSeparator && (
        <div style={{ width: '4.25rem' }}>
          <SimpleInput
            label='Frequency'
            min={1}
            max={10}
            onInput={handleGridlineFrequencyChange}
            onBlur={handleFixGridlineFrequency}
            type={'number'}
            value={gapAnalysisFilters.gridlinesFrequency}
          />
        </div>
      )}
    </div>
  )
}

export default DisplayOptionsGA
